import React from 'react';
import { ButtonGroup, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import DecimalInputWithButtons from '../../Inputs/DecimalInputWithButtons';

const SitAndReachErgebnisInput = (props) => {
    const style = {
        display: 'block ruby',
        padding: '10px'
    };
    return (
        <div>
            <div style={style}>
                <h5 style={style}>Versuch 1:</h5>
                <DecimalInputWithButtons
                    identifier="versuch1Input"
                    value={props.SitAndReachErgebnis[0]}
                    onValueChange={(value) => props.onChange(1, value)}
                    unit="cm"
                />

            </div>
            <div style={style}>
                <h5 style={style}>Versuch 2:</h5>
                <DecimalInputWithButtons
                    identifier="versuch2Input"
                    value={props.SitAndReachErgebnis[1]}
                    onValueChange={(value) => props.onChange(2, value)}
                    unit="cm"
                />
            </div>
        </div>
    );
};

export default SitAndReachErgebnisInput;